<template>
    <div class="warranty-status-piechart">
        <div class="row mt-4">
            <div class="cols-sm-12 col-md-12 col-lg-12">
                <h3 class="mb-4">Warranties</h3>
            </div>

            <div class="col-sm-12 col-md-8 col-lg-8">
                <div class="row mt-4">
                    <div class="col-sm-12 col-md-4 col-lg-3">
                        <ul class="warranty-stats">
                            <li class="request-stats">
                                <span>{{ this.requestCount }}</span>
                                <span> Warranty request</span>
                            </li>
                            <li class="active-stats">
                                <span>{{ this.openCount }}</span>
                                <span>Active Warranty</span>
                            </li>
                            <li class="close-stats">
                                <span>{{ this.closedCount }}</span>
                                <span>Close Warranty</span>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-12 col-md-8 col-lg-9">
                        <apexchart v-if="!loading" type="pie" height="300" :options="pieChartOptions" :series="pieSeries" />
                        <div v-else class="text-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import moment from 'moment';
export default {
    name: 'WarrantyStatusPiechart',
    components: {
        apexchart: VueApexCharts
    },
    props: {
        startDate: {
            type: [Date, String],
            required: false,
            default: null
        },
        endDate: {
            type: [Date, String],
            required: false,
            default: null
        }
    },
    computed: {
        pieSeries() {
            return [this.requestCount, this.openCount, this.closedCount];
        }
    },
    data() {
        return {
            loading: true,
            requestCount: 0,
            openCount: 0,
            closedCount: 0,
            // Pie Chart Series and Options
            pieChartOptions: {
                chart: {
                    type: 'bar'
                },
                labels: ['Warranty Request', 'Warranty Active', 'Warranty Closed'],
                colors: ['#e70413', '#146081', '#000000'],
                legend: {
                    show: false,
                    position: 'bottom'
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        },
                        fill: {
                            color: '#FFFFFF' // black on hover
                        }
                    }
                },

                dataLabels: {
                    enabled: true,
                    offsetX: 10,
                    offsetY: 0,
                    formatter: function (val, opts) {
                        return opts.w.globals.series[opts.seriesIndex];
                    },
                    style: {
                        colors: ['#ffffff'],
                        fontSize: '16px',
                        fontWeight: 'bold'
                    },
                    dropShadow: {
                        enabled: false
                    }
                }
            }
        };
    },
    mounted() {
        this.getWarrantyStats();
        console.log(this.startDate, this.endDate);
    },
    methods: {
        getWarrantyStats() {
            let url = `${Env.baseUrl}/v2/superadmin/reg-product/get-warranty-tickets-count-by-status`;
            if (this.startDate && this.endDate) {
                const startDateStr = typeof this.startDate === 'string' ? this.startDate : moment(this.startDate).format('YYYY-MM-DD');
                const endDateStr = typeof this.endDate === 'string' ? this.endDate : moment(this.endDate).format('YYYY-MM-DD');
                url += `?startDate=${startDateStr}&endDate=${endDateStr}`;
            }
            AuthApis.getApi(url)
                .then((res) => {
                    this.requestCount = res.data.payload.request;
                    this.openCount = res.data.payload.open;
                    this.closedCount = res.data.payload.closed;
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
        }
    }
};
</script>
